import visit from 'unist-util-visit';

export default function WordCount() {
    let wordCount:number = 0;

    return transformer;
    
    function transformer(tree: any, file: any) {

        visit(tree, 'WordNode', increment, true);

        function increment(node:Node) {
            wordCount++;
            return visit.SKIP;
        }
        
        file.wordCount = wordCount;
    }
}